import React, { memo } from 'react';
import Dropdown from '@components/dropdown';
import SentimentAnalysis from '@components/charts/sentimentChart';
import ESG_CSR from './summary/ESGandCSR';
import CyberSecurity from './summary/CyberSecurity';
import { ANALYSIS_SUB_PERMISSIONS } from '@model';

const AnalysisCstmzWrapper = ({
  title,
  segmentId,
  dropdownList,
  sendData,
  permission,
  data,
  refetch,
}) => {
  if (!segmentId) {
    return null;
  }
  const Comp =
    {
      [ANALYSIS_SUB_PERMISSIONS.esgAndCsr]: ESG_CSR,
      [ANALYSIS_SUB_PERMISSIONS.sentimentanalysis]: SentimentAnalysis,
      [ANALYSIS_SUB_PERMISSIONS.cyberSecurity]: CyberSecurity,
    }[segmentId] || (() => null);

  return (
    <div className="analysisContainer">
      <div className="leftContent">
        <Dropdown
          title={title}
          list={dropdownList}
          sendData={sendData}
          permission={permission}
        />
        <Comp data={data} refetch={refetch} currentSubmoduleName={title} />
      </div>
    </div>
  );
};

export default memo(AnalysisCstmzWrapper);
